import { memo } from 'react';
import { ThemeImage } from '../../../../controls/ThemeImage/ThemeImage';
import { BackIcon } from '../BackIcon/BackIcon';
import { CartIcon } from '../CartIcon/CartIcon';
import { SaveIcon } from '../SaveIcon/SaveIcon';
import css from '../Header.module.scss';
import type { WebHeaderProps } from './WebHeader.types';

export const WebHeader = memo((props: WebHeaderProps) => (
    <nav data-testid={'web-header-nav'} className={css.nav}>
        <div className={css.leftIcons}>
            <div>
                <BackIcon />
            </div>
            <div>
                <SaveIcon />
            </div>
        </div>
        <div className={css.mobileLogo}>
            <ThemeImage themeImageType={'mobileHeaderLogo'} />
        </div>
        <div className={css.rightIcons}>
            <CartIcon onClick={props.onCartClick} count={props.cartCount} />
        </div>
    </nav>
));
